import { injectable } from 'inversify'
import type { MntnConversionType } from '@/services/tracking/types'

export type MntnConversionPayload = {
  conversionType: MntnConversionType
  orderId?: string
  orderAmt?: string | number
}

@injectable()
export class MntnTrackingService {
  protected readonly shaid = '64212'

  public trackConversion({ conversionType, orderId = '', orderAmt = '' }: MntnConversionPayload): void {
    const { referrer, parentHref } = this.getPageContext()
    const cb = Math.floor(Math.random() * 1e17)
    const params = new URLSearchParams({
      conv: '1',
      shaid: this.shaid,
      tdr: referrer,
      plh: parentHref,
      cb: String(cb),
      shoid: String(orderId),
      shoamt: String(orderAmt),
      type: conversionType,
      shocur: '',
      shopid: '',
      shoq: '',
      shoup: '',
      shpil: '',
    })
    this.injectPixelScript(`https://dx.mountain.com/spx?${params.toString()}`)
  }

  protected getPageContext(): { referrer: string; parentHref: string } {
    let referrer: string
    let parentHref: string
    try {
      referrer =
        // @ts-expect-error custom props from mntn tracker
        // eslint-disable-next-line
        top?.document?.referer !== ''
          ? // eslint-disable-next-line
            encodeURIComponent((top?.document?.referrer ?? '').substring(0, 2048))
          : ''
    } catch {
      referrer = document.referrer !== null ? document.referrer.toString().substring(0, 2048) : ''
    }
    try {
      parentHref =
        // eslint-disable-next-line
        parent.location.href !== '' ? encodeURIComponent(parent.location.href.toString().substring(0, 2048)) : ''
    } catch {
      parentHref = ''
    }
    return { referrer, parentHref }
  }

  protected injectPixelScript(src: string): void {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = src

    const scripts = document.getElementsByTagName('script')
    const anchor = scripts[scripts.length - 1]
    anchor?.parentNode?.insertBefore(script, anchor)
  }
}
